import { render, staticRenderFns } from "./SelectedUserGroupItem.vue?vue&type=template&id=719cdca5&scoped=true&"
import script from "./SelectedUserGroupItem.vue?vue&type=script&lang=ts&"
export * from "./SelectedUserGroupItem.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedUserGroupItem.vue?vue&type=style&index=0&id=719cdca5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719cdca5",
  null
  
)

export default component.exports